import type { FireSafetyEmptyStateTranslations } from "../../types/fireSafetyEmptyState";

export const fireSafetyEmptyState: FireSafetyEmptyStateTranslations = {
  title: "Tuleohutuse info pole seadistatud",
  description:
    "Seadista tuleohutuse info, et jälgida hoone tuleohutuse ennetus- ja reageerimissüsteeme.",
  bulletHeading: "Olulised jälgitavad ohutussüsteemid:",
  bullets: [
    "Tuletõrjesignalisatsioon",
    "Sprinklersüsteemid",
    "Avariivalgustus",
    "Tulekustutid",
    "Evakuatsiooniteed",
  ],
  setupButton: "Seadista tuleohutuse info",
};
